import { css } from '@emotion/css';
import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { fetchAddress, fetchUtility } from './api/api';
import { useMyStore } from './common/store/AppStoreProvider';
import { ChooseDataSourceModal } from './components/choose-data-source-modal';
import { Button } from './components/styles/Button.styled';
import type { Address, Utilities } from './types';

export const ValidateAddress = () => {
    const { t } = useTranslation('homepage');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [addressOptions, setAddressOptions] = useState<Address[]>([]);
    const [selectedAddress, setSelectedAddress] = useState<Address[]>([]);
    const [showDataSourceModal, setShowDataSourceModal] = useState(false);
    const [loadingUtility, setLoadingUtility] = useState(false);
    const [utility, setUtility] = useState<Utilities[]>([]);
    const [selectedUtility, setSelectedUtility] = useState<Utilities | undefined>(undefined);

    const { setAddress } = useMyStore()

    useEffect(() => {
        const savedAddress = localStorage.getItem('saved_address');
        if (savedAddress) {
            fetchAddress(savedAddress).then(data => {
                if (data && data.length > 0) {
                    setSelectedAddress(data);
                }
            })
        }
    }, []);

    useEffect(() => {
        if (selectedAddress.length === 0) return;
        setLoadingUtility(true);
        const { zipcode } = selectedAddress[0];
        fetchUtility(zipcode).then(res => {
            setLoadingUtility(false);
            if (res) {
                setUtility(res);
                setSelectedUtility(res[0]);
            }
        })
    }, [selectedAddress])

    const handleSearch = (val: string) => {
        setLoading(true);
        fetchAddress(val).then(data => {
            setAddressOptions(data);
            setLoading(false);
        })
    }

    const handleClick = () => {
        if (selectedAddress.length === 0) return;
        const address = selectedAddress[0];
        localStorage.setItem('saved_address', address.street);
        const utilityCode = selectedUtility ? selectedUtility.utility_code : '';
        address.utcode = utilityCode
        setAddress(address)
        const { street, esiid, zipcode, city, state } = address;
        // setShowDataSourceModal(true);
        let params = `?address=${encodeURIComponent(`${street}`)}&esiid=${esiid}&zipcode=${zipcode}&city=${(encodeURIComponent(`${city}`))}&state=${state}&utcode=${utilityCode}`;
        navigate(`/analysis_report${params}`);
    }

    const redirectTo = (type: string) => {
        const address = selectedAddress[0];
        const { street, esiid, zipcode, city, state } = address;
        const utilityCode = selectedUtility ? selectedUtility.utility_code : '';

        navigate(`/get_usage?address=${encodeURIComponent(street)}&esiid=${esiid}&zipcode=${zipcode}&city=${city}&state=${state}&source=${type}&utcode=${utilityCode}`);
    }

    const chooseUtility = () => {
        if (utility.length <= 1 || !selectedUtility) return null;
        return (
            <Dropdown className="utility-select">
                <Dropdown.Toggle variant="light">
                    {selectedUtility.utility_name}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {
                        utility.map((val, idx) => (
                            <Dropdown.Item
                                eventKey={idx}
                                key={idx}
                                onClick={() => {
                                    setSelectedUtility(val);
                                }}
                                active={val.utility_id === selectedUtility.utility_id}
                            >{val.utility_name}</Dropdown.Item>
                        ))
                    }
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    return (
        <>
            <div className="autocomplete-address-row">
                <div id="autocomplete-wrapper">
                    <AsyncTypeahead
                        filterBy={() => true}
                        id="autocomplete"
                        isLoading={loading}
                        labelKey="label"
                        minLength={1}
                        onSearch={handleSearch}
                        options={addressOptions}
                        placeholder={`${t('Address')}...`}
                        size="lg"
                        onChange={(val: any) => setSelectedAddress(val)}
                        selected={selectedAddress}
                    />
                </div>
                {chooseUtility()}
            </div>
            <Button
                onClick={handleClick}
                disabled={!selectedAddress[0] || loadingUtility}
                className={css`
                    margin-top: 20px;
                    @media (max-width: 990px) {
                        width: 100%;
                    }
                `}
            >
                <span>Start Now</span>
            </Button>
            <ChooseDataSourceModal
                show={showDataSourceModal}
                handleClose={() => { setShowDataSourceModal(false); }}
            />
        </>
    )
}